module.exports = __webpack_public_path__ + "resource/img/icon_language1.png?5e6f564048619f2981797d5b4ebdd209";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_language1.png
// module id = 449
// module chunks = 36